/**
 * Shown when a live Firestore listener has given up (subscribe/
 * subscribeDoc exhaust their reconnect attempts and call onError).
 * Without this the page either spins forever (error before the first
 * snapshot) or silently keeps rendering STALE data — a caregiver
 * checking the Activity page would trust an out-of-date press list.
 */

import { Button } from '@/components/ui/Button';

export function LoadErrorBanner({
  what,
  onRetry,
}: {
  /** Short noun for what failed, e.g. "the calendar" / "today's presses". */
  what: string;
  onRetry: () => void;
}) {
  return (
    <div
      role="alert"
      className="flex flex-wrap items-center justify-between gap-3 rounded-lg border border-red-300 bg-red-50 px-4 py-3 text-sm text-red-900"
    >
      <span>
        Couldn't load {what} — what you see may be out of date. Check your
        connection.
      </span>
      <Button variant="secondary" size="sm" onClick={onRetry}>
        Try again
      </Button>
    </div>
  );
}
